import React, { ChangeEvent } from 'react';
import {
	TextBlock,
	Select,
	Option,
	TextField
} from 'neon-design-system';
import { Grid } from '@material-ui/core';
import { FormControl } from '../../../utils/form.utils';

interface StripeTaxIdProps {
	taxIdFormControl: FormControl<string>;
	businessNameFormControl: FormControl<string>;
	businessCountryFormControl: FormControl<Option | undefined>;
	countryOptions: Option[];
	removeTaxIdErrorMessage: () => void;
}

export const StripeTaxId = ({
	taxIdFormControl,
	businessNameFormControl,
	businessCountryFormControl,
	countryOptions,
	removeTaxIdErrorMessage
}: StripeTaxIdProps) => {
	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<TextBlock styleName="footnote">
					We need your business details for invoicing purposes.
				</TextBlock>
			</Grid>
			<Grid item xs={12}>
				<TextField
					id="business-name-input"
					fullWidth
					error={businessNameFormControl?.showError}
					errorText={businessNameFormControl?.validationMessage}
					type="text"
					label="Business name"
					autoComplete="off"
					value={businessNameFormControl?.value}
					onBlur={businessNameFormControl?.handleBlur}
					onChange={(e: ChangeEvent<any>): void => {
						const val: string = e?.target?.value;
						businessNameFormControl?.setValue(val);
						removeTaxIdErrorMessage();
					}}
				/>
			</Grid>
			<Grid item xs={12}>
				<Select
					id="business-country-select"
					size="medium"
					menuPlacement="bottom"
					label="Where is the business registered?"
					placeholder="Select country"
					value={businessCountryFormControl?.value}
					onBlur={businessCountryFormControl?.handleBlur}
					error={businessCountryFormControl?.showError}
					errorText={businessCountryFormControl?.validationMessage}
					onChange={(opt: Option): void => {
						businessCountryFormControl?.setValue(opt);
						removeTaxIdErrorMessage();
					}}
					options={countryOptions}
					clearable={false}
				/>
			</Grid>
			<Grid item xs={12}>
				<TextField
					id="tax-id-input"
					fullWidth
					error={taxIdFormControl?.showError}
					errorText={taxIdFormControl?.validationMessage}
					type="text"
					label="Tax identification number or VAT number"
					autoComplete="off"
					value={taxIdFormControl?.value}
					onBlur={taxIdFormControl?.handleBlur}
					onChange={(e: ChangeEvent<any>): void => {
						const val: string = e?.target?.value;

						if (taxIdFormControl?.showError) {
							removeTaxIdErrorMessage();
						}

						taxIdFormControl?.setValue(val);
					}}
					helperText="If using a VAT (value-added tax) number, include the 2-letter country code."
				/>
			</Grid>
		</Grid>
	)
}
